/**
 * DOM/platform polyfills for the LEGACY (SystemJS) build only.
 *
 * @vitejs/plugin-legacy covers ECMAScript built-ins via core-js,
 * but core-js deliberately excludes web platform APIs. This module
 * is injected into the legacy polyfill chunk through the plugin's
 * `additionalLegacyPolyfills` option (see vite.config.ts) and
 * installs the two web APIs EdgeHTML 18 lacks that the app's
 * vendor stack reaches for:
 *
 *   - ResizeObserver (Radix primitives, Recharts)
 *   - TextEncoder/TextDecoder (byte/string conversions in vendor
 *     code and WebAuthn helpers)
 *
 * Modern browsers never load this: it ships only in the legacy
 * chunk, which the browser-detection snippet loads exclusively on
 * engines without dynamic-import support.
 */

import "fast-text-encoding";
import { ResizeObserver as ResizeObserverPolyfill } from "@juggle/resize-observer";

if (typeof window !== "undefined" && typeof window.ResizeObserver === "undefined") {
  window.ResizeObserver = ResizeObserverPolyfill as unknown as typeof ResizeObserver;
}
